import { FEATURE } from "../../../consts/Common";
import { GALLERY_SCHEMA } from "../../../consts/Template";
import Configs from "../../../Configurations";
import imgPlaceholder from "../../images/img-placeholder-half.svg";

const blob_url = Configs?.REACT_APP_IMAGE_STORAGE_URL || "https://blob.sparknotifications.walmart.com";

const FiveAndTen = {
  [GALLERY_SCHEMA.ID]: "comms_five_and_ten",
  [GALLERY_SCHEMA.NAME]: "5 and 10",
  [GALLERY_SCHEMA.CATEGORY]: FEATURE.COMMS_TEMPLATES,
  template_content: `<mjml>
  <mj-head>
    <mj-style>
      p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
      ul, ol { margin-block-start:0; margin-block-end:0; padding-block-start:0; padding-block-end:0; Margin:0; }
      a { color: inherit; text-decoration: underline; }
      @media only screen and (max-width:479px) {
        .mobile-stack-gap { padding-bottom: 24px !important; }
        .mobile-img-no-pad table td { width: 100% !important; }
        .mobile-no-left-pad td { padding-left: 0px !important; }
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f0f0f0">

    <!-- Top Banner -->
    <mj-section
      padding-top="3px"
      padding-bottom="3px"
      padding-left="3px"
      padding-right="3px"
      background-color="#ffffff">
      <mj-column width="30%" vertical-align="middle">
        <mj-image
          src="${blob_url}/templateeditortestteam-image/WMT-Wordmark-Standard-TrueBlue-RGB.png"
          padding-top="20px"
          padding-bottom="20px"
          padding-left="20px"
          padding-right="20px">
        </mj-image>
      </mj-column>
      <mj-column width="70%" vertical-align="middle" css-class="mobile-stack-gap">
        <mj-text
          padding-top="5px"
          padding-bottom="5px"
          padding-left="15px"
          padding-right="5px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32">Link 1&nbsp; &nbsp; Link 2&nbsp; &nbsp; Link 3&nbsp; &nbsp; Link 4&nbsp; &nbsp; Link 5</span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Blue Title -->
    <mj-section
      padding-top="3px"
      padding-bottom="3px"
      padding-left="3px"
      padding-right="3px"
      background-color="#0053E2">
      <mj-column>
        <mj-text
          padding-top="16px"
          padding-bottom="16px"
          padding-left="5px"
          padding-right="5px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><strong><span style="font-size:20pt"><span style="color:#ffffff">Walmart 5&amp;10</span></span></strong></p>
          <p style="text-align:center"><span style="font-size:12pt"><strong><span style="color:#ffffff">Walmart Week {{week}} | {{date}}</span></strong></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Feature Split -->
    <mj-section
      padding-top="24px"
      padding-bottom="24px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="40%" vertical-align="middle" css-class="mobile-stack-gap">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="12px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.4">
          <p style="text-align:center"><strong><span style="font-size:20px"><span style="color:#2E2F32">Type your text here</span></span></strong></p>
          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32">{ Subtitle here; }</span></span></p>
        </mj-text>
        <mj-button
          padding-top="8px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="12px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="14px"
          background-color="#0053E2"
          border-radius="1000px"
          height="32px"
          inner-padding="0px 16px"
          font-weight="bold"
          color="#ffffff"
          font-style="normal">
          Button
        </mj-button>
      </mj-column>
      <mj-column width="60%" vertical-align="middle" css-class="mobile-no-left-pad">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="12px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna.</span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Section 1 Headline -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.4">
          <p style="text-align:center"><strong><span style="font-size:20px"><span style="color:#2E2F32">Section Headline Goes Here //*</span></span></strong></p>
        </mj-text>
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          border-color="#E3E4E5">
        </mj-divider>
      </mj-column>
    </mj-section>

    <!-- Section 1 Article -->
    <mj-section
      padding-top="16px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="55%" css-class="mobile-stack-gap">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="24px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur amet consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</span></span></p>
        </mj-text>
      </mj-column>
      <mj-column width="45%" css-class="mobile-img-no-pad">
        <mj-image
          src="${imgPlaceholder}"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          container-background-color="#FDF4F4">
        </mj-image>
      </mj-column>
    </mj-section>

    <!-- Section 1 Links -->
    <mj-section
      padding-top="16px"
      padding-bottom="24px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</u></span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Consectetur adipiscing elit ut aliquam purus sit amet.</u></span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Adipiscing elit duis tristique sollicitudin nibh.</u></span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Section 2 Headline + Links -->
    <mj-section
      padding-top="0px"
      padding-bottom="24px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.4">
          <p style="text-align:center"><strong><span style="font-size:20px"><span style="color:#2E2F32">Section Headline Goes Here **/</span></span></strong></p>
        </mj-text>
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          border-color="#E3E4E5">
        </mj-divider>
        <mj-text
          padding-top="16px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem ipsum dolor scelerisque orci aliquam sit amet.</u></span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem ipsum dolor scelerisque orci aliquam sit amet.</u></span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem ipsum dolor scelerisque orci aliquam sit amet.</u></span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Add to Calendar -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="20px"
          line-height="1.4">
          <p style="text-align:center"><strong><span style="font-size:20px"><span style="color:#2E2F32">Add to Calendar</span></span></strong></p>
        </mj-text>
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          border-color="#E3E4E5">
        </mj-divider>
        <mj-text
          padding-top="16px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><span style="font-size:16px"><span style="color:#515357">Type your text here.</span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Calendar Dates -->
    <mj-section
      padding-top="16px"
      padding-bottom="24px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column css-class="mobile-stack-gap">
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="24px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Date 1:</span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem Ipsum</u></span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Dolor sit amet, consectetur</u></span></span></p>
        </mj-text>
        <mj-text
          padding-top="16px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="24px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Date 2:</span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem Ipsum</u></span></span></p>
        </mj-text>
        <mj-text
          padding-top="16px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="24px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Date 3:</span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem Ipsum dolor</u></span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem ipsum</u></span></span></p>
        </mj-text>
      </mj-column>
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Date 4:</span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem Ipsum dolor sit amet</u></span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</u></span></span></p>
        </mj-text>
        <mj-text
          padding-top="16px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p><span style="font-size:16px"><span style="color:#2E2F32">Date 5:</span></span></p>
          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem Ipsum</u></span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Footer -->
    <mj-section
      padding-top="32px"
      padding-bottom="32px"
      padding-left="24px"
      padding-right="24px"
      background-color="#F3F3F3">
      <!-- Column 1: Social icons — no column-level padding; all spacing at content level -->
      <mj-column padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" css-class="mobile-stack-gap">
        <mj-social
          font-size="12px"
          border-radius="50%"
          mode="horizontal"
          padding-top="0px"
          padding-bottom="8px"
          padding-left="16px"
          padding-right="16px">
          <mj-social-element border-radius="50%" icon-size="32px" name="workvivo-noshare" src="${blob_url}/xmwrgbcr-image/kwwbf659-workvivo-icon.png" background-color="#9966F5"></mj-social-element>
          <mj-social-element border-radius="50%" icon-size="32px" name="twitter-noshare" src="${blob_url}/xmwrgbcr-image/kwwcupmb-twitter-icon.png" background-color="#000000"></mj-social-element>
          <mj-social-element border-radius="50%" icon-size="32px" name="linkedin-noshare" src="${blob_url}/xmwrgbcr-image/kwwcuq26-linkedin-icon.png" background-color="#0A66C2"></mj-social-element>
        </mj-social>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="16px"
          padding-right="16px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
        </mj-text>
      </mj-column>
      <!-- Column 2: Left image — no column-level padding; all spacing at content level -->
      <mj-column padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" css-class="mobile-stack-gap">
        <mj-image
          src="${imgPlaceholder}"
          padding-top="0px"
          padding-bottom="8px"
          padding-left="16px"
          padding-right="16px">
        </mj-image>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="16px"
          padding-right="16px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
        </mj-text>
      </mj-column>
      <!-- Column 3: Right image — no column-level padding; all spacing at content level -->
      <mj-column padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px">
        <mj-image
          src="${imgPlaceholder}"
          padding-top="0px"
          padding-bottom="8px"
          padding-left="16px"
          padding-right="16px">
        </mj-image>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="16px"
          padding-right="16px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          line-height="1.5">
          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
        </mj-text>
      </mj-column>
    </mj-section>

  </mj-body>
</mjml>`,
  [GALLERY_SCHEMA.PREVIEW]: `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    body { margin: 0; padding: 0; }
    table, td { border-collapse: collapse; }
    img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
    p { display: block; margin: 13px 0; }
    p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
    ul, ol { margin-block-start: 0; margin-block-end: 0; padding-block-start: 0; padding-block-end: 0; Margin: 0; }
    a { color: inherit; text-decoration: underline; }
    @media only screen and (max-width:479px) {
      .mobile-stack-gap { padding-bottom: 24px !important; }
      .mobile-img-no-pad table td { width: 100% !important; }
      .mobile-no-left-pad { padding-left: 0px !important; }
    }
  </style>
</head>
<body style="word-spacing:normal;background-color:#f0f0f0;">
  <div style="background-color:#f0f0f0;">

    <!-- Top Banner -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:3px;padding-bottom:3px;padding-left:3px;padding-right:3px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:30%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:20px;padding-bottom:20px;padding-left:20px;padding-right:20px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;margin:0 auto;">
                          <tbody>
                            <tr>
                              <td style="width:138px;">
                                <img src="${blob_url}/templateeditortestteam-image/WMT-Wordmark-Standard-TrueBlue-RGB.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="138" height="auto" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mobile-stack-gap" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:70%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:5px;padding-bottom:5px;padding-left:15px;padding-right:5px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:13px;line-height:1.5;text-align:left;color:#000000;">
                          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32">Link 1&nbsp; &nbsp; Link 2&nbsp; &nbsp; Link 3&nbsp; &nbsp; Link 4&nbsp; &nbsp; Link 5</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Blue Title -->
    <div style="background:#0053E2;background-color:#0053E2;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0053E2;background-color:#0053E2;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:3px;padding-bottom:3px;padding-left:3px;padding-right:3px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:16px;padding-bottom:16px;padding-left:5px;padding-right:5px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:13px;line-height:1.5;text-align:left;color:#000000;">
                          <p style="text-align:center"><strong><span style="font-size:20pt"><span style="color:#ffffff">Walmart 5&amp;10</span></span></strong></p>
                          <p style="text-align:center"><span style="font-size:12pt"><strong><span style="color:#ffffff">Walmart Week {{week}} | {{date}}</span></strong></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Feature Split -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:24px;padding-bottom:24px;padding-left:24px;padding-right:24px;text-align:center;">
              <div class="mobile-stack-gap" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:40%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:12px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:20px;line-height:1.4;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><strong><span style="font-size:20px"><span style="color:#2E2F32">Type your text here</span></span></strong></p>
                          <p style="text-align:center"><span style="font-size:14px"><span style="color:#2E2F32">{ Subtitle here; }</span></span></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:8px;padding-bottom:0px;padding-left:0px;padding-right:12px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#0053E2" role="presentation" style="border:none;border-radius:1000px;cursor:auto;font-style:normal;height:32px;background:#0053E2;" valign="middle">
                                <p style="display:inline-block;background:#0053E2;color:#ffffff;font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;font-style:normal;font-weight:bold;line-height:120%;margin:0;text-decoration:none;padding:0px 16px;border-radius:1000px;">
                                  Button
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mobile-no-left-pad" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:60%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:12px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit amet. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna.</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Section 1 Headline -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:20px;line-height:1.4;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><strong><span style="font-size:20px"><span style="color:#2E2F32">Section Headline Goes Here //*</span></span></strong></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <p style="border-top:solid 1px #E3E4E5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Section 1 Article -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div class="mobile-stack-gap" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:55%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:24px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Lorem ipsum dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur amet consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mobile-img-no-pad" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:45%;background-color:#FDF4F4;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:100%;">
                                <img src="${imgPlaceholder}" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100%" height="auto" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Section 1 Links -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:16px;padding-bottom:24px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</u></span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Consectetur adipiscing elit ut aliquam purus sit amet.</u></span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Adipiscing elit duis tristique sollicitudin nibh.</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Section 2 Headline + Links -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:0px;padding-bottom:24px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:20px;line-height:1.4;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><strong><span style="font-size:20px"><span style="color:#2E2F32">Section Headline Goes Here **/</span></span></strong></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <p style="border-top:solid 1px #E3E4E5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem ipsum dolor scelerisque orci aliquam sit amet.</u></span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem ipsum dolor scelerisque orci aliquam sit amet.</u></span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem ipsum dolor scelerisque orci aliquam sit amet.</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Add to Calendar -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:24px;padding-right:24px;text-align:center;">
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:20px;line-height:1.4;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><strong><span style="font-size:20px"><span style="color:#2E2F32">Add to Calendar</span></span></strong></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <p style="border-top:solid 1px #E3E4E5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#515357;">
                          <p style="text-align:center"><span style="font-size:16px"><span style="color:#515357">Type your text here.</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Calendar Dates -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:16px;padding-bottom:24px;padding-left:24px;padding-right:24px;text-align:center;">
              <div class="mobile-stack-gap" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:50%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:24px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Date 1:</span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem Ipsum</u></span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Dolor sit amet, consectetur</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:0px;padding-right:24px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Date 2:</span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem Ipsum</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:0px;padding-right:24px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Date 3:</span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem Ipsum dolor</u></span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem ipsum</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:50%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Date 4:</span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem Ipsum dolor sit amet</u></span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:16px;padding-bottom:0px;padding-left:0px;padding-right:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><span style="font-size:16px"><span style="color:#2E2F32">Date 5:</span></span></p>
                          <p><span style="font-size:16px"><span style="color:#2E2F32"><u>Lorem Ipsum</u></span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Footer -->
    <div style="background:#F3F3F3;background-color:#F3F3F3;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#F3F3F3;background-color:#F3F3F3;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding-top:32px;padding-bottom:32px;padding-left:24px;padding-right:24px;text-align:center;">
              <div class="mobile-stack-gap" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:33.333333%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:16px;padding-right:16px;word-break:break-word;">
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#9966F5;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img src="${blob_url}/xmwrgbcr-image/kwwbf659-workvivo-icon.png" style="border-radius:50%;display:block;" width="32" height="auto" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img src="${blob_url}/xmwrgbcr-image/kwwcupmb-twitter-icon.png" style="border-radius:50%;display:block;" width="32" height="auto" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0A66C2;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img src="${blob_url}/xmwrgbcr-image/kwwcuq26-linkedin-icon.png" style="border-radius:50%;display:block;" width="32" height="auto" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:16px;padding-right:16px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mobile-stack-gap" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:33.333333%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:16px;padding-right:16px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:100%;">
                                <img src="${imgPlaceholder}" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100%" height="auto" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:16px;padding-right:16px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:33.333333%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding-top:0px;padding-bottom:8px;padding-left:16px;padding-right:16px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:100%;">
                                <img src="${imgPlaceholder}" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100%" height="auto" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding-top:0px;padding-bottom:0px;padding-left:16px;padding-right:16px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><span style="font-size:16px"><span style="color:#2E2F32">Type your text here.</span></span></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</body>
</html>`,
};
export default FiveAndTen;
